import ReactDOMServer from 'react-dom/server';
import {
  AppCard,
  AppInputNumber,
  AppMultiSelect,
  AppSingleSelect,
} from '@/layout/AppComponents';
import Translator from '../../../components/helpers/Translator';

export default function ModuleComsaEnvironmentalCivilConstruction(props) {
  const {
    values,
    errors,
    setFieldValue,
    noYesOptions,
    affectedServicesOptions,
    courseOccupancyTimeOptions,
  } = props;

  return (
    <AppCard
      header={ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="civil" />
      )}
      className="mb-2"
    >
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.produce.asphalt.mix.on.site"
          />
        )}
        value={values?.particleBoardManufacturing}
        error={errors?.particleBoardManufacturing}
        onChange={(opt) => setFieldValue('particleBoardManufacturing', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="asphalt.project.yes.indicate.estimated.tonnes"
          />
        )}
        value={values?.particleBoard}
        error={errors?.particleBoard}
        onChange={(opt) => setFieldValue('particleBoard', opt)}
        isClearable
      />
      {values?.particleBoard === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.quantity.tonnes"
              />
            )}
            onChange={(value) => setFieldValue('particleBoardQuantity', value)}
            value={values?.particleBoardQuantity}
            error={errors?.particleBoardQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="is.there.need.produce.concrete.site"
          />
        )}
        value={values?.concreteNeed}
        error={errors?.concreteNeed}
        onChange={(opt) => setFieldValue('concreteNeed', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.install.aggregate.crushing.plant.on.site"
          />
        )}
        value={values?.aridCrushing}
        error={errors?.aridCrushing}
        onChange={(opt) => setFieldValue('aridCrushing', opt)}
        isClearable
      />
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="indicate.total.volume.earthworks.excavations.embankments.fillings.etc"
          />
        )}
        onChange={(value) => setFieldValue('soilMovementQuantity', value)}
        value={values?.soilMovementQuantity}
        error={errors?.soilMovementQuantity}
        isClearable
      />
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="planned.duration.earthworks.execution.months"
          />
        )}
        onChange={(value) => setFieldValue('plannedPeriodSoilMovement', value)}
        value={values?.plannedPeriodSoilMovement}
        error={errors?.plannedPeriodSoilMovement}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="there.need.install.generators.yes.indicate.quantity"
          />
        )}
        value={values?.generatorNeed}
        error={errors?.generatorNeed}
        onChange={(opt) => setFieldValue('generatorNeed', opt)}
        isClearable
      />
      {values?.generatorNeed === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.number.generators"
              />
            )}
            onChange={(value) => setFieldValue('generatorNeedNumber', value)}
            value={values?.generatorNeedNumber}
            error={errors?.generatorNeedNumber}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="blasting.expected.yes.indicate.estimated.volume"
          />
        )}
        value={values?.demolitionNeed}
        error={errors?.demolitionNeed}
        onChange={(opt) => setFieldValue('demolitionNeed', opt)}
        isClearable
      />
      {values?.demolitionNeed === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) => setFieldValue('demolitionNeedQuantity', value)}
            value={values?.demolitionNeedQuantity}
            error={errors?.demolitionNeedQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="works.expected.storage.handling.products.susceptible.explosion"
          />
        )}
        value={values?.flammableProducts}
        error={errors?.flammableProducts}
        onChange={(opt) => setFieldValue('flammableProducts', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.carry.out.extractive.activities.yes.indicate.estimated.volume"
          />
        )}
        value={values?.extractorActivities}
        error={errors?.extractorActivities}
        onChange={(opt) => setFieldValue('extractorActivities', opt)}
        isClearable
      />
      {values?.extractorActivities === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('extractorActivitiesQuantity', value)
            }
            value={values?.extractorActivitiesQuantity}
            error={errors?.extractorActivitiesQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.stockpile.aggregates.yes.indicate.estimated.volume"
          />
        )}
        value={values?.aridCollection}
        error={errors?.aridCollection}
        onChange={(opt) => setFieldValue('aridCollection', opt)}
        isClearable
      />
      {values?.aridCollection === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) => setFieldValue('aridCollectionQuantity', value)}
            value={values?.aridCollectionQuantity}
            error={errors?.aridCollectionQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="plan.build.concrete.structures.yes.indicate.square.meters.structures"
          />
        )}
        value={values?.concreteStructuresConstruction}
        error={errors?.concreteStructuresConstruction}
        onChange={(opt) => setFieldValue('concreteStructuresConstruction', opt)}
        isClearable
      />
      {values?.concreteStructuresConstruction === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.square.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('concreteStructuresConstructionQuantity', value)
            }
            value={values?.concreteStructuresConstructionQuantity}
            error={errors?.concreteStructuresConstructionQuantity}
            isClearable
          />
        </div>
      )}
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="indicate.number.people.involved.project.during.peak.periods"
          />
        )}
        onChange={(value) => setFieldValue('personNumber', value)}
        value={values?.personNumber}
        error={errors?.personNumber}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="structural.concrete.expected.used.yes.indicate.total.volume"
          />
        )}
        value={values?.concreteStructuresUse}
        error={errors?.concreteStructuresUse}
        onChange={(opt) => setFieldValue('concreteStructuresUse', opt)}
        isClearable
      />
      {values?.concreteStructuresUse === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('concreteStructuresUseQuantity', value)
            }
            value={values?.concreteStructuresUseQuantity}
            error={errors?.concreteStructuresUseQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="plan.use.mass.concrete.yes.indicate.total.volume"
          />
        )}
        value={values?.concreteMassUse}
        error={errors?.concreteMassUse}
        onChange={(opt) => setFieldValue('concreteMassUse', opt)}
        isClearable
      />
      {values?.concreteMassUse === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('concreteMassUseQuantity', value)
            }
            value={values?.concreteMassUseQuantity}
            error={errors?.concreteMassUseQuantity}
            isClearable
          />
        </div>
      )}
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="total.volume.concrete.cubic.meters"
          />
        )}
        onChange={(value) => setFieldValue('concreteTotal', value)}
        value={values?.concreteTotal}
        error={errors?.concreteTotal}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="there.need.occupy.watercourses"
          />
        )}
        value={values?.courseOccupancy}
        error={errors?.courseOccupancy}
        onChange={(opt) => setFieldValue('courseOccupancy', opt)}
        isClearable
      />
      {values?.courseOccupancy === 1 && (
        <div className="pl-4">
          <AppSingleSelect
            options={courseOccupancyTimeOptions}
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.whether.occupation.will.temporary.permanent"
              />
            )}
            value={values?.courseOccupancyTime}
            error={errors?.courseOccupancyTime}
            onChange={(opt) => setFieldValue('courseOccupancyTime', opt)}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.exploit.gravel.pits.yes.indicate.estimated.volume"
          />
        )}
        value={values?.gravelBedExploitation}
        error={errors?.gravelBedExploitation}
        onChange={(opt) => setFieldValue('gravelBedExploitation', opt)}
        isClearable
      />
      {values?.gravelBedExploitation === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('gravelBedExploitationQuantity', value)
            }
            value={values?.gravelBedExploitationQuantity}
            error={errors?.gravelBedExploitationQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.open.roads.access.tracks.yes.indicate.length.meters.roads.access.tracks"
          />
        )}
        value={values?.pathOpening}
        error={errors?.pathOpening}
        onChange={(opt) => setFieldValue('pathOpening', opt)}
        isClearable
      />
      {values?.pathOpening === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.length.meters"
              />
            )}
            onChange={(value) => setFieldValue('pathOpeningQuantity', value)}
            value={values?.pathOpeningQuantity}
            error={errors?.pathOpeningQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.install.machinery.yard.on.site"
          />
        )}
        value={values?.machinerySet}
        error={errors?.machinerySet}
        onChange={(opt) => setFieldValue('machinerySet', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.demolish.structures.yes.indicate.estimated.volume"
          />
        )}
        value={values?.structuresDemolition}
        error={errors?.structuresDemolition}
        onChange={(opt) => setFieldValue('structuresDemolition', opt)}
        isClearable
      />
      {values?.structuresDemolition === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('structuresDemolitionQuantity', value)
            }
            value={values?.structuresDemolitionQuantity}
            error={errors?.structuresDemolitionQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="knowledge.possible.presence.asbestos.demolition.dismantling.phase"
          />
        )}
        value={values?.asbestos}
        error={errors?.asbestos}
        onChange={(opt) => setFieldValue('asbestos', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="demolitions.include.transformer.stations"
          />
        )}
        value={values?.transformationCenters}
        error={errors?.transformationCenters}
        onChange={(opt) => setFieldValue('transformationCenters', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.surface.demolitions.yes.indicate.square.meters.demolished"
          />
        )}
        value={values?.superficialDemolition}
        error={errors?.superficialDemolition}
        onChange={(opt) => setFieldValue('superficialDemolition', opt)}
        isClearable
      />
      {values?.superficialDemolition === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.area.square.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('superficialDemolitionQuantity', value)
            }
            value={values?.superficialDemolitionQuantity}
            error={errors?.superficialDemolitionQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.perform.autogenous.welding.site"
          />
        )}
        value={values?.autogenousSoldering}
        error={errors?.autogenousSoldering}
        onChange={(opt) => setFieldValue('autogenousSoldering', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="luminous.signaling.work.area.yes.indicate.number.beacons.installed"
          />
        )}
        value={values?.illuminatedSignposting}
        error={errors?.illuminatedSignposting}
        onChange={(opt) => setFieldValue('illuminatedSignposting', opt)}
        isClearable
      />
      {values?.illuminatedSignposting === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.number.beacons"
              />
            )}
            onChange={(value) =>
              setFieldValue('illuminatedSignpostingNumber', value)
            }
            value={values?.illuminatedSignpostingNumber}
            error={errors?.illuminatedSignpostingNumber}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="piling.shielding.planned.yes.indicate.estimated.concreting.volume"
          />
        )}
        value={values?.screenExecution}
        error={errors?.screenExecution}
        onChange={(opt) => setFieldValue('screenExecution', opt)}
        isClearable
      />
      {values?.screenExecution === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('screenExecutionQuantity', value)
            }
            value={values?.screenExecutionQuantity}
            error={errors?.screenExecutionQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="is.prefabricated.pile.driving.planned"
          />
        )}
        value={values?.prefabricatedPiling}
        error={errors?.prefabricatedPiling}
        onChange={(opt) => setFieldValue('prefabricatedPiling', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.waterproofing.structures.yes.indicate.area.waterproofed"
          />
        )}
        value={values?.structuresWaterproofing}
        error={errors?.structuresWaterproofing}
        onChange={(opt) => setFieldValue('structuresWaterproofing', opt)}
        isClearable
      />
      {values?.structuresWaterproofing === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.area.square.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('structuresWaterproofingQuantity', value)
            }
            value={values?.structuresWaterproofingQuantity}
            error={errors?.structuresWaterproofingQuantity}
            isClearable
          />
        </div>
      )}
      {values?.structuresWaterproofing === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.density.kilograms.per.square.meter"
              />
            )}
            onChange={(value) =>
              setFieldValue('structuresWaterproofingQuantity2', value)
            }
            value={values?.structuresWaterproofingQuantity2}
            error={errors?.structuresWaterproofingQuantity2}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="horizontal.signaling.planned.yes.indicate.linear.meters"
          />
        )}
        value={values?.horizontalSignPosting}
        error={errors?.horizontalSignPosting}
        onChange={(opt) => setFieldValue('horizontalSignPosting', opt)}
        isClearable
      />
      {values?.horizontalSignPosting === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('horizontalSignPostingQuantity', value)
            }
            value={values?.horizontalSignPostingQuantity}
            error={errors?.horizontalSignPostingQuantity}
            isClearable
          />
        </div>
      )}
      {values?.horizontalSignPosting === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.square.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('horizontalSignPostingQuantity2', value)
            }
            value={values?.horizontalSignPostingQuantity2}
            error={errors?.horizontalSignPostingQuantity2}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.construct.sheet.pile.walls.project"
          />
        )}
        value={values?.tablestacadoNeed}
        error={errors?.tablestacadoNeed}
        onChange={(opt) => setFieldValue('tablestacadoNeed', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="possibility.impact.historical.artistic.heritage.archaeological.sites.project"
          />
        )}
        value={values?.archaeologicalAffection}
        error={errors?.archaeologicalAffection}
        onChange={(opt) => setFieldValue('archaeologicalAffection', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="expected.traffic.disruptions.closures.diversions.project"
          />
        )}
        value={values?.trafficAffection}
        error={errors?.trafficAffection}
        onChange={(opt) => setFieldValue('trafficAffection', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="expected.pedestrian.affections.random.routes.access.closures.project"
          />
        )}
        value={values?.pedestrianAffection}
        error={errors?.pedestrianAffection}
        onChange={(opt) => setFieldValue('pedestrianAffection', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="possibility.temporary.water.intakes.example.irrigation.concrete.production.curing"
          />
        )}
        value={values?.temporaryWaterCollection}
        error={errors?.temporaryWaterCollection}
        onChange={(opt) => setFieldValue('temporaryWaterCollection', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="plan.build.structures.masonry.works.viaducts.watercourse.areas"
          />
        )}
        value={values?.structureConstructionWaterCourse}
        error={errors?.structureConstructionWaterCourse}
        onChange={(opt) =>
          setFieldValue('structureConstructionWaterCourse', opt)
        }
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="earthworks.expected.watercourse.areas"
          />
        )}
        value={values?.soilMovementWaterCourse}
        error={errors?.soilMovementWaterCourse}
        onChange={(opt) => setFieldValue('soilMovementWaterCourse', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="tunnel.consolidation.expected.gunita.yes.indicate.estimated.volume.gunita"
          />
        )}
        value={values?.tunnelStrengthening}
        error={errors?.tunnelStrengthening}
        onChange={(opt) => setFieldValue('tunnelStrengthening', opt)}
        isClearable
      />
      {values?.tunnelStrengthening === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('tunnelStrengtheningQuantity', value)
            }
            value={values?.tunnelStrengtheningQuantity}
            error={errors?.tunnelStrengtheningQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="clearing.pruning.bushes.trees.expected"
          />
        )}
        value={values?.treeClear}
        error={errors?.treeClear}
        onChange={(opt) => setFieldValue('treeClear', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="expected.increase.employment.construction.works.socioeconomic.impact.study"
          />
        )}
        value={values?.employmentIncrease}
        error={errors?.employmentIncrease}
        onChange={(opt) => setFieldValue('employmentIncrease', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="expected.increase.economic.activity.area.execution.construction.socioeconomic.impact.study"
          />
        )}
        value={values?.economicActivityIncrease}
        error={errors?.economicActivityIncrease}
        onChange={(opt) => setFieldValue('economicActivityIncrease', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="expected.decrease.economic.activity.area.execution.construction.socioeconomic.impact.study"
          />
        )}
        value={values?.economicActivityDecrease}
        error={errors?.economicActivityDecrease}
        onChange={(opt) => setFieldValue('economicActivityDecrease', opt)}
        isClearable
      />
      <AppMultiSelect
        options={affectedServicesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="affected.services.work.area.yes.select.type.affected.services"
          />
        )}
        value={values?.affectedServices || []}
        error={errors?.affectedServices}
        onChange={(opt) => setFieldValue('affectedServices', opt)}
        hasSelectOptions
      />
    </AppCard>
  );
}
